<template>
  <div class="titulo">
    <div class="margem container">
      <h2>{{ title }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {type: String, required: true}
  }
}
</script>
